export enum Bilanzierungsmodell {
    PLANWERT = 'PLANWERT',
    PROGNOSE = 'PROGNOSE'
}

export class BilanzierungsmodellItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): BilanzierungsmodellItem[] {
        return [
            new BilanzierungsmodellItem(Bilanzierungsmodell.PLANWERT, 'Z01 = Planwert'),
            new BilanzierungsmodellItem(Bilanzierungsmodell.PROGNOSE, 'Z02 = Prognose'),
        ];
    }

}

